/**
 * スクロール時のブラーフェードインアニメーション
 * IntersectionObserverで画面内に入った要素にクラスを付与
 *
 * .blurTrigger  → .blur  クラスを付与（軽いブラー）
 * .blurTrigger2 → .blur2 クラスを付与（強いブラー）
 *
 * CSS定義は custom-ummclair.css を参照
 */
(function () {
  /* IntersectionObserver 非対応ブラウザは即時表示 */
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.blurTrigger, .blurTrigger2').forEach(function (el) {
      el.style.opacity = '1';
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          if (el.classList.contains('blurTrigger2')) {
            el.classList.add('blur2');
          } else {
            el.classList.add('blur');
          }
          observer.unobserve(el);
        }
      });
    },
    { threshold: 0.1 }
  );

  document.querySelectorAll('.blurTrigger, .blurTrigger2').forEach(function (el) {
    observer.observe(el);
  });
})();
